import { z } from 'zod/v4';

import { WritableQuoteBuilderStateType } from '../../types/state';
import { IssueInsertType } from '../../types/state/issues';
import { buildElementId } from '../utilities/element-id';
import { buildIssueId } from '../utilities/issue-id';
import { deleteIssue, upsertIssue } from '../utilities/issue-managers';

export const leadTimeNotesValidator = z
  .string({ error: 'Notes are required' })
  .max(50, 'Notes must be less than 50 characters')
  .min(1, 'Notes cannot be empty');

type ValidateLeadTimeNotesParams = {
  leadTimeNotes: string;
  quoteLineUuid: string;
};
export function validateLeadTimeNotes(
  state: WritableQuoteBuilderStateType,
  { leadTimeNotes, quoteLineUuid }: ValidateLeadTimeNotesParams,
) {
  const issueId = buildIssueId({
    area: 'quoteLine',
    quoteLineUuid,
    type: 'invalid',
    field: 'leadTimeNotes',
  });

  const result = leadTimeNotesValidator.safeParse(leadTimeNotes);

  if (result.success) {
    deleteIssue(state, issueId);
    return result.data;
  }
  const error = z.flattenError(result.error).formErrors[0];

  upsertIssue(state, issueId, {
    title: 'Invalid lead time notes.',
    description: error,
    severity: 'error',
    type: 'invalid',
    field: 'leadTimeNotes',
    area: 'quoteLine',
    quoteLineUuid,
    action: {
      type: 'modify',
      elementId: buildElementId({
        uuid: quoteLineUuid,
        field: 'leadTimeNotes',
      }),
    },
  } satisfies IssueInsertType);

  return leadTimeNotes;
}
